import { Badge } from "@/components/ui/badge";
import {
  inviteStatus,
  inviteStatusLabel,
  inviteTrackingCaveat,
  isInviteProblem,
  type InviteTimestamps,
} from "@produce/shared";

/**
 * How far a crew invitation got.
 *
 * Whether a status counts as a failure is decided in @produce/shared, not by a
 * ternary here — the first version of that ternary quietly rendered "Marked as
 * spam" in the same neutral grey as "Sent".
 *
 * "Sent" is never styled as a problem: an invitation from before delivery
 * tracking existed has no history and never will. Its tooltip says so.
 */
export default function InviteBadge({ member }: { member: InviteTimestamps }) {
  const status = inviteStatus(member);
  const caveat = inviteTrackingCaveat(member);

  const variant = isInviteProblem(status)
    ? "destructive"
    : status === "opened" || status === "delivered"
      ? "default"
      : "secondary";

  return (
    <Badge variant={variant} title={caveat}>
      {inviteStatusLabel(status)}
    </Badge>
  );
}
